module.exports = __webpack_public_path__ + "static/DmytriiStepanenko-35e95d8e75763c2827e0f368356a2ae2.jpeg";